module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"success-message":"Successfully copied code","error-message":"Error copying over code, please copy manually","copy":"Copy snippet"},"de":{"success-message":"Code erfolgreich kopiert","error-message":"Fehler beim Kopieren des Codes, bitte manuell kopieren","copy":"Snippet kopieren"}}')
  delete Component.options._Ctor
}
